import axios from "axios";
import { API } from "@/apiConfig";

const DEFAULTS = { cc_db_surcharge: 0, min_credit_debit_amount: 0 };

// Which card terminal this register uses (PAX A35 or ModeskPay/ModeskP1). Returns the terminal's
// settings in the PAX-compatible shape the payment screens already understand, plus `driver`
// ("pax" | "dejavoo") which picks the backend route prefix (/pax/* or /dejavoo/*).
export async function fetchTerminalSettings(stationId) {
  const sid = stationId || "default";
  const { data: active } = await axios.get(`${API}/settings/terminal?station_id=${sid}`);
  if (active?.terminal_type === "dejavoo") {
    const { data: dj } = await axios.get(`${API}/settings/dejavoo?station_id=${sid}`);
    return { ...DEFAULTS, ...dj, driver: "dejavoo", ip_address: dj.mode === "cloud" ? "cloud" : (dj.local_ip || "") };
  }
  const { data: pax } = await axios.get(`${API}/settings/pax?station_id=${sid}`);
  return { ...DEFAULTS, ...pax, driver: "pax" };
}

export const terminalRoute = (settings) => (settings?.driver === "dejavoo" ? "dejavoo" : "pax");
export const terminalLabel = (settings) => (settings?.driver === "dejavoo" ? "ModeskP1" : "PAX terminal");
